import { materialBusiness } from "api/bussiness/material/material-bussiness";
import { workOrderPoBusiness } from "api/bussiness/work-order-po/work-order-po-bussiness";
import {
  ControlPropertiesWithoutNameAndValue,
  ObjectSchemaType,
} from "commons/ultilities/dynamic-form/hooks/use-form";
import { InputType } from "commons/ultilities/dynamic-form/models/control";
import {
  IAddMaterialGoodsIssue,
  IUpdateMaterialGoodsIssue,
} from "mobx-stores/_models/material-inventory/material-goods-issue/material-goods-issue";
import { IMaterialGoodsIssueItemProperties } from "mobx-stores/_models/material-inventory/material-goods-issue/material-goods-issue-item";
import { date, number, string } from "yup";

const issueDateFieldSchema: ControlPropertiesWithoutNameAndValue = {
  type: InputType.datePicker,
  gridSize: 12,
  label: "Ngày xuất",
  validattionYupSchema: date().required(),
};

const getGoodsIssueItemsArraySchema =
  (): ObjectSchemaType<IMaterialGoodsIssueItemProperties> => ({
    workOrderId: {
      type: InputType.none,
    },
    workOrderPOId: {
      type: InputType.autoComplete,
      gridSize: 12,
      label: "Lệnh sản xuất",
      validattionYupSchema: string(),
      metaData: {
        searchOptionItemsAsync: async (keyword: string) => {
          return await workOrderPoBusiness.searchWoPoAsOptionItems(keyword);
        },
      },
    },
    materialId: {
      type: InputType.autoComplete,
      gridSize: 6,
      label: "Vật tư",
      validattionYupSchema: string().required(),
      metaData: {
        searchOptionItemsAsync: async (keyword: string) => {
          return await materialBusiness.searchMaterialsAsOptionItems(keyword);
        },
      },
    },
    brand: {
      type: InputType.select,
      gridSize: 6,
      label: "Hiệu",
      validattionYupSchema: string(),
    },
    department: {
      type: InputType.text,
      gridSize: 12,
      label: "Bộ phận",
      validattionYupSchema: string(),
    },
    amount: {
      type: InputType.number,
      gridSize: 12,
      label: "Số lượng",
      validattionYupSchema: number().required().min(0),
    },
    note: {
      type: InputType.textArea,
      gridSize: 12,
      label: "Ghi chú",
      validattionYupSchema: string(),
    },
  });

export const getAddMaterialGoodsIssueSchema =
  (): ObjectSchemaType<IAddMaterialGoodsIssue> => ({
    issueDate: issueDateFieldSchema,
    items: {
      arraySchema: getGoodsIssueItemsArraySchema(),
    },
  });

export const getUpdateMaterialGoodsIssueSchema =
  (): ObjectSchemaType<IUpdateMaterialGoodsIssue> => ({
    id: {
      type: InputType.none,
    },
    issueDate: issueDateFieldSchema,
    items: {
      arraySchema: {
        id: {
          type: InputType.none,
          defaultValue: "",
        },
        ...getGoodsIssueItemsArraySchema(),
      },
    },
  });
